
<script>

let active = false;
function togglehamburger() {

}
</script>

<header>
  <div class="logo"><img src="./images/logo.svg" alt="logo"></div>
  <section class="header-container">
  <button id="hamburger" class:active={active} class="hamburger hamburger--squeeze" type="button" on:click="{() => active = !active}">
    <span class="hamburger-box">
      <span class="hamburger-inner"></span>
    </span>
  </button>
  <!--<button type="button" class="button button-sidebar"><span class="icon icon-sidebar"><i class="fa-solid fa-door-open"></i></span><span class="button-text">button-text</span></button>-->
  <div id="current-user" class="current-user"><span>current user</span></div>
</section>
</header>
